import $ from 'jquery';
export class DestinationNotAvailableModal {
    // element;
    constructor(element) {
        this.element = $(element);
        this.element.find('.back, .close').on('click', this.closeClicked.bind(this));
    }

    openExclusiveDistributor(countryName, distributorName, website) {
        this.element.find('.exclusivity-message').css('display', '');
        this.element.find('.destination-not-available-message').css('display', 'none');
        this.element.find('.country').text(countryName);
        this.element.find('a.distributor').text(distributorName).attr('href', website);
        this.element.css('display', 'block');
    }

    openDestinationNotAvailable(countryName) {
        this.element.find('.exclusivity-message').css('display', 'none');
        this.element.find('.destination-not-available-message').css('display', '');
        this.element.find('.country').text(countryName);
        this.element.find('a.distributor').text('').attr('href', '#');
        this.element.css('display', 'block');
    }

    closeClicked(event) {
        if (event) {
            event.preventDefault();
        }
        this.element.css('display', 'none');
    }
}